module.exports = __webpack_public_path__ + "img/1556849891.4c5a3813.jpg";